import React, { useState } from "react";
import CreateIncident from "./incidents_create";

function IncidentsData ({ master }) {
    const [view, setView] = useState('incidentsData');

    const handleAddIncident = () => {
        setView('createIncident');
    }

    return(
        <>
            <div className="container-fluid">
                    <div className="row">
                        <div className="col-3">
                            <p><span className="fw-bold">Master:</span> {master.number} </p>
                        </div>
                        <div className="col-3">
                            <p><span className="fw-bold">Piezas:</span> {master.pzas} </p>
                        </div>
                        <div className="col-3">
                            <p><span className="fw-bold">Peso:</span> {master.weight} </p>
                        </div>
                        <div className="col-3">
                            <p><span className="fw-bold">Tipo:</span> {master.type} </p>
                        </div>
                    </div>
                    {view === 'incidentsData' && (
                    <>
                    <div className="row">
                        <div className="col d-flex justify-content-end">
                            <button className='btnn' onClick={handleAddIncident} >Agregar incidencia</button>
                        </div>
                    </div>

                    <table className="table table-striped mt-3">
                        <thead className="text-center">
                            <tr>
                                <th style={{ backgroundColor: '#020C41', color: 'white' }}>Piezas</th>
                                <th style={{ backgroundColor: '#020C41', color: 'white' }}>Peso</th>
                                <th style={{ backgroundColor: '#020C41', color: 'white' }}>Tipo</th>
                                <th style={{ backgroundColor: '#020C41', color: 'white' }}>Observaciones</th>
                                <th style={{ backgroundColor: '#020C41', color: 'white' }}>Fecha y hora</th>
                                <th style={{ backgroundColor: '#020C41', color: 'white' }}>Seguimiento</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            <tr>
                                <td colSpan={6}>No hay incidencias</td>
                            </tr>
                        </tbody>
                    </table>
                    </>
                )}

                {view === 'createIncident' && <CreateIncident />}
            </div>
        </>
    );
}

export default IncidentsData;